//const baseUrl = 'http://121.37.146.199/admin'
//const baseUrl = 'http://127.0.0.1:8080'y
const baseUrl = 'http://know.gmmatou.com'

export default{
  baseUrl
}



// WEBPACK FOOTER //
// ./src/api/global-config.js